import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TablePagination, Typography, 
  IconButton
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

const ProductPurchasedAverageCost = ({ data }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Calculate totals
  const totalQuantity = data?.reduce((sum, item) => sum + (item.quantity_left || 0), 0);
  const totalValue = data?.reduce((sum, item) => sum + (parseFloat(item.total_value) || 0), 0);

  const handlePrint = (rows) => { 
    try {
      if (!rows || rows.length === 0)
        return alert("No rows to print.");

      const storeInfo = {
        logo: localStorage.getItem("businessLogo") || "",
        businessName: localStorage.getItem("businessName"),
      };

      const printWindow = window.open("", "_blank");

      // const footerRemarks = `<tr><td colspan=4>ټوټل بیلینس	 </td> <td> ${totalBalance}</td></tr>`

      const newTableRows = rows
        .map(
          (row) => `
          <tr>
            <td>${row.total_value || ""}</td> 
            <td>${row?.quantity_full || ""}</td>
            <td>${row?.quantity_left || ""}</td>
            <td>${row?.latest_average_price || ""}</td>
            <td>${row.product_name || ""}</td>
          </tr>`
        )
        .join("");

      const logoPath = storeInfo.logo
        ? storeInfo.logo
        : "/images/logos/Logo.png";

      const styles = `
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        body {
          font-family: 'Noto Naskh Arabic', sans-serif;
          margin: 0;
          background-color: white;
           background-repeat: no-repeat;
          background-position: center 50%;
          background-size: 60%;
          -webkit-print-color-adjust: exact !important;
        }
        .page {
          width: 210mm;
          min-height: 297mm;
          padding: 10px;          /* ✅ 10px left & right */
          box-sizing: border-box;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 4px;
          text-align: center;
        }
        thead {
          display: table-header-group; 
          color: white;
        }
        tbody tr:nth-child(odd) {
          background-color: #f9f9f9;
        }
        .header-info {
          text-align: center;
          font-size: 13px;
          padding: 4px 0;
        }
        .logo {
          max-width: 60px;
        }
        footer {
          text-align: center;
          font-size: 11px;
          margin-top: 10px;
        }
      </style>
    `;

      const printHTML = `
      <html lang="ps">
        <head>
          <meta charset="UTF-8" />
          <title>بیل</title>
          ${styles}
        </head>
<body>
  <div class="page">
    <table>
              <thead>
                <tr style="color: black">
                  <td colspan="6" class="header-info" style="border:0px">
                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <div style="float: right; text-align: right;">
                      <h3 style="margin: 0; padding:0px; font-size: 12px">
                        ټوله پاته جنس ، مقدار/تعداد ، اوسط قیمت اوټوټل ارزښت
                      </h3>
                        </div>
                      <div style="text-align:left;">
                        <img src="${logoPath}" class="logo" />
                        <h2 style="font-size:12px; margin:0;">${storeInfo.businessName || ""}</h2>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr style="background-color: #ffa800">
                  <th>ټوټل</th> 
                  <th>پلور سوی	</th>
                  <th>پاته تعداد/مقدار	</th>
                  <th>اوسط قیمت خرید</th>
                  <th>جنس</th>
                </tr>
              </thead>
              <tbody>
                ${newTableRows}
              </tbody>
            </table>
          </div>

          <footer>© ${new Date().getFullYear()} ${"واصلي ټیکنالوژي 0703131865"}</footer>

          <script>
            window.onload = () => {
              window.print();
              window.onafterprint = () => window.close();
            };
          </script>
        </body>
      </html>
    `;

      printWindow.document.open();
      printWindow.document.write(printHTML);
      printWindow.document.close();
    } catch (err) {
      console.error("Error printing bill:", err);
    }
  };
  return (
    <Paper elevation={3} sx={{ padding: 2 }}>
      <Typography variant="h6" gutterBottom style={{direction:'rtl'}}>
        <IconButton aria-label="print" onClick={()=> handlePrint(data)}>
          <PrintIcon />
        </IconButton>
        ټوله پاته جنس ، مقدار/تعداد ، اوسط قیمت اوټوټل ارزښت
      </Typography>

      <TableContainer>
        <Table >
          <TableHead>
            <TableRow>
              <TableCell>جنس</TableCell> 
              <TableCell align="right">اوسط قیمت خرید</TableCell>
              <TableCell align="right">پاته تعداد/مقدار</TableCell>
              <TableCell align="right">ټوټل</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
              <TableRow key={item.product_id || index}>
                <TableCell>{item.product_name || 'N/A'}</TableCell>
                <TableCell align="right">{parseFloat(item.latest_average_price || 0)?.toFixed(2)}</TableCell>
                <TableCell align="right">{parseFloat(item.quantity_left || 0)?.toFixed(2)}</TableCell>
                <TableCell align="right">{parseFloat(item.total_value || 0)?.toFixed(2)}</TableCell>
              </TableRow>
            ))}

            {/* Total Row */}
            <TableRow sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
              <TableCell><strong>دټولو جنسو ټوټل ارزښت</strong></TableCell>
              <TableCell align="right">—</TableCell> {/* Leave average blank or customize if needed */}
              <TableCell align="right">
               — {/* <strong>{totalQuantity?.toFixed(2)}</strong> */}
                </TableCell>
              <TableCell align="right"><strong>{parseFloat(totalValue || 0)?.toFixed(2)}</strong></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={data?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default ProductPurchasedAverageCost;
